import type { GamesResponse } from '../game/types';

export const EMPTY_GAMES_RESPONSE: GamesResponse = {
  games: [],
  hasMoreGames: false,
};
